import { render } from "./sourcetree.vue?vue&type=template&id=3c031952&scoped=true"
import script from "./sourcetree.vue?vue&type=script&lang=js"
export * from "./sourcetree.vue?vue&type=script&lang=js"

import "./sourcetree.vue?vue&type=style&index=0&id=3c031952&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c031952"]])

export default __exports__